<template>
  <div class="public-content attr-management">
    <div class="region-title" style="background: #fff">属性值色块管理</div>
    <div class="add-category">
      <el-button round type="primary" @click="type = 'add', addDialog = true">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column min-width="200px" prop="propVal" label="属性值"> </el-table-column>
        <el-table-column min-width="200px" prop="propKey" label="属性名"></el-table-column>
        <el-table-column width="200px" prop="blockWordColor" label="对应色块">
          <template slot-scope="scope">
            <div class="boxF" v-if="scope.row.blockShape === 'HEXAGON'">
              <div class="boxS">
                <div class="boxT" :style="'border:' + `1px solid ${scope.row.blockBorderColor}` + ';background:' + scope.row.blockBgColor + ';color:' + scope.row.blockWordColor + ';'">{{
                    scope.row.blockWord
                }}</div>
              </div>
            </div>
            <div class="CIRCULAR" :style="'border:' + `1px solid ${scope.row.blockBorderColor}` + ';background:' + scope.row.blockBgColor + ';color:' + scope.row.blockWordColor + ';'"
              v-if="scope.row.blockShape === 'CIRCULAR'"> {{ scope.row.blockWord }} </div>
            <div class="SQUARE" :style="'border:' + `1px solid ${scope.row.blockBorderColor}` + ';background:' + scope.row.blockBgColor + ';color:' + scope.row.blockWordColor + ';'"
              v-if="scope.row.blockShape === 'SQUARE'"> {{ scope.row.blockWord }} </div>
            <div class="TRIANGLE" :style="'border:' + `1px solid ${scope.row.blockBorderColor}` + ';border-bottom: 23px solid ' + scope.row.blockBgColor + ';color:' + scope.row.blockWordColor + ';'"
              v-if="scope.row.blockShape === 'TRIANGLE'">
              <span class="TRIANGLE_content">{{ scope.row.blockWord }}</span>
            </div>
            <div class="PENTAGON" :style="'border:' + `1px solid ${scope.row.blockBorderColor}` + ';background:' + scope.row.blockBgColor + ';color:' + scope.row.blockWordColor + ';'"
              v-if="scope.row.blockShape === 'PENTAGON'"> {{ scope.row.blockWord }} </div>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template slot-scope="scope">
            <span class="color-blue" @click="clickEdit(scope)">编辑<br></span>
            <span class="color-blue" @click="deleteId = scope.row.id, deleteDialog = true">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 添加/编辑 -->
    <el-dialog :close-on-click-modal="false" :title="type === 'add' ? '添加' : '编辑'" @closed='closed' :visible.sync="addDialog" width="30%">
      <el-form ref="form" :model="addSpuDictAttrVO" :rules="addFormRules" label-width="100px">
        <el-form-item label="属性名" prop="spuDictKeyId">
          <el-select v-model="addSpuDictAttrVO.spuDictKeyId" @change="getPropVals" placeholder="请选择">
            <el-option v-for="item in propKeys" :key="item.id" :label="item.propKey" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性值" prop="spuDictValueId">
          <el-select v-model="addSpuDictAttrVO.spuDictValueId" placeholder="请选择">
            <el-option v-for="item in propVals" :key="item.id" :label="item.propVal" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="色块形状" prop="blockShape">
          <el-select v-model="addSpuDictAttrVO.blockShape" placeholder="请选择">
            <el-option v-for="item in blockShapeList" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="色块背景色" prop="blockBgColor">
          <el-color-picker v-model="addSpuDictAttrVO.blockBgColor" @change="getblockBgColor" color-format=""></el-color-picker>
        </el-form-item>
        <el-form-item label="形状边框色" prop="blockBorderColor">
          <el-color-picker v-model="addSpuDictAttrVO.blockBorderColor" @change="getblockBorderColor" color-format=""></el-color-picker>
        </el-form-item>
        <el-form-item label="色块文字" prop="blockWord">
          <el-input v-model="addSpuDictAttrVO.blockWord" max="1" placeholder="请输入内容" maxlength="1"></el-input>
        </el-form-item>
        <el-form-item label="文字颜色" prop="blockWordColor">
          <el-color-picker v-model="addSpuDictAttrVO.blockWordColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="色块预览">
          <div class="boxF" v-if="addSpuDictAttrVO.blockShape === 'HEXAGON'">
            <div class="boxS">
              <div class="boxT"
                :style="'border:' + `1px solid ${addSpuDictAttrVO.blockBorderColor}` + ';background:' + addSpuDictAttrVO.blockBgColor + ';color:' + addSpuDictAttrVO.blockWordColor + ';'"> {{
                    addSpuDictAttrVO.blockWord
                }}</div>
            </div>
          </div>
          <div class="CIRCULAR"
            :style="'border:' + `1px solid ${addSpuDictAttrVO.blockBorderColor}` + ';background:' + addSpuDictAttrVO.blockBgColor + ';color:' + addSpuDictAttrVO.blockWordColor + ';'"
            v-if="addSpuDictAttrVO.blockShape === 'CIRCULAR'"> {{ addSpuDictAttrVO.blockWord }} </div>
          <div class="SQUARE" :style="'border:' + `1px solid ${addSpuDictAttrVO.blockBorderColor}` + ';background:' + addSpuDictAttrVO.blockBgColor + ';color:' + addSpuDictAttrVO.blockWordColor + ';'"
            v-if="addSpuDictAttrVO.blockShape === 'SQUARE'"> {{ addSpuDictAttrVO.blockWord }} </div>
          <div class="TRIANGLE"
            :style="'border:' + `1px solid ${addSpuDictAttrVO.blockBorderColor}` + ';border-bottom: 23px solid ' + addSpuDictAttrVO.blockBgColor + ';color:' + addSpuDictAttrVO.blockWordColor + ';'"
            v-if="addSpuDictAttrVO.blockShape === 'TRIANGLE'">
            <span class="TRIANGLE_content">{{ addSpuDictAttrVO.blockWord }}</span>
          </div>
          <div class="PENTAGON"
            :style="'border:' + `1px solid ${addSpuDictAttrVO.blockBorderColor}` + ';background:' + addSpuDictAttrVO.blockBgColor + ';color:' + addSpuDictAttrVO.blockWordColor + ';'"
            v-if="addSpuDictAttrVO.blockShape === 'PENTAGON'">
            <span style="margin-left: 6px">{{ addSpuDictAttrVO.blockWord }}</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancle">取 消</el-button>
        <el-button type="primary" @click="addColor">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该属性吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteColor">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { spuDictAttrList, dictListNoPaging, dictQueryByPid, spuDictAttrDelete, spuDictAttrUpdate, blockShape, spuDictAttrAdd } from '@/api/pms'
export default {
  name: 'attr-management',
  components: {
    VPagination
  },
  data () {
    return {
      type: '',
      blockShapeList: [],
      addSpuDictAttrVO: {
        blockBorderColor: '',
        blockBgColor: '',
        blockShape: '',
        blockWord: '',
        blockWordColor: '',
        spuDictKeyId: '',
        spuDictValueId: ''
      },
      propKeys: [],
      propVals: [],
      addDialog: false,
      deleteId: '',
      deleteDialog: false,
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addFormRules: {
        spuDictKeyId: [
          { required: true, message: '请选择属性名', trigger: 'change' }
        ],
        spuDictValueId: [
          { required: true, message: '请选择属性值', trigger: 'change' }
        ],
        blockShape: [
          { required: true, message: '请选择色块形状', trigger: 'change' }
        ],
        blockBgColor: [
          { required: true, message: '请选择背景色', trigger: 'change' }
        ],
        blockBorderColor: [
          { required: true, message: '请选择形状边框色', trigger: 'change' }
        ],
        blockWord: [
          { required: true, message: '请填写色块文字', trigger: 'blur' }
        ],
        blockWordColor: [
          { required: true, message: '请选择文字颜色', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getAttrColorList()
    this.getPropKeys()
    this.getBlockShapeList()
  },
  methods: {
    clickEdit (k) {
      this.addSpuDictAttrVO = k.row
      this.addDialog = true
      this.type = 'edit'
    },
    onCancle () {
      this.addDialog = false
      this.getAttrColorList()
    },
    getblockBgColor (e) {
      console.log(e)
    },
    deleteColor () {
      spuDictAttrDelete(this.deleteId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getAttrColorList()
          this.deleteDialog = false
        }
      })
    },
    closed () {
      this.addSpuDictAttrVO = {
        blockBgColor: '',
        blockShape: '',
        blockWord: '',
        blockWordColor: '',
        spuDictKeyId: '',
        spuDictValueId: ''
      }
      this.$refs.form.resetFields()
      this.getAttrColorList()
    },
    addColor () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type === 'add') {
            spuDictAttrAdd(this.addSpuDictAttrVO).then(res => {
              if (res.data.success) {
                this.$message.success('添加成功')
                this.getAttrColorList()
                this.addDialog = false
              }
            })
          } else if (this.type === 'edit') {
            spuDictAttrUpdate({ id: this.addSpuDictAttrVO.id, spuDictAttrVO: this.addSpuDictAttrVO }).then(res => {
              if (res.data.success) {
                this.$message.success('修改成功')
                this.getAttrColorList()
                this.addDialog = false
              }
            })
          }
        }
      })
    },
    getBlockShapeList () {
      blockShape().then(res => {
        if (res.data.success) {
          this.blockShapeList = res.data.data
        }
      })
    },
    getPropVals (val) {
      dictQueryByPid(val).then(res => {
        if (res.data.success) {
          this.propVals = res.data.data
        }
      })
    },
    getPropKeys () {
      dictListNoPaging(-1).then(res => {
        if (res.data.success) {
          this.propKeys = res.data.data
        }
      })
    },
    getAttrColorList () {
      spuDictAttrList(this.queryInfo).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getAttrColorList()
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getAttrColorList()
    }
  }
}
</script>
 <style scoped lang="less">
 @import "./styles";
 @deep: ~">>>";
 
 .TRIANGLE {
   width: 0px;
   height: 0px;
   // box-sizing: border-box;
   text-align: center;
   border-left: 15px solid rgba(0, 0, 0, 0);
   border-right: 15px solid rgba(0, 0, 0, 0);
   margin-left: 8px;
   position: relative;
 }
 
 .TRIANGLE_content {
   position: absolute;
   left: -3px;
   text-align: center;
 }
 
 .SQUARE {
   width: 25px;
   height: 25px;
   margin-left: 8px;
   text-align: center;
 }
 
 .CIRCULAR {
   text-align: center;
   width: 25px;
   height: 25px;
   border-radius: 100%;
   margin-left: 8px;
 }
 
 .boxF,
 .boxS,
 .boxT,
 .overlay {
   width: 20px;
   height: 25px;
   overflow: hidden;
 }
 
 .boxF,
 .boxS {
   visibility: hidden;
 }
 
 .boxF {
   transform: rotate(120deg);
   float: left;
   margin-left: 10px;
   -ms-transform: rotate(120deg);
   -moz-transform: rotate(120deg);
   -webkit-transform: rotate(120deg);
 }
 
 .boxS {
   transform: rotate(-60deg);
   -ms-transform: rotate(-60deg);
   -moz-transform: rotate(-60deg);
   -webkit-transform: rotate(-60deg);
 }
 
 .boxT {
   text-align: center;
   transform: rotate(-60deg);
   background: no-repeat 50% center;
   background-size: 125% auto;
   -ms-transform: rotate(-60deg);
   -moz-transform: rotate(-60deg);
   -webkit-transform: rotate(-60deg);
   visibility: visible;
   line-height: 25px;
 }
 
 .PENTAGON {
   width: 25px;
   height: 25px;
   float: left;
   position: relative;
   margin-left: 10px;
   clip-path: polygon(50% 0, 0 50%, 20% 100%, 80% 100%, 100% 50%);
 }
 </style>
